import React, { useEffect, useState } from 'react';

function formatDateTime(iso) {
  if (!iso) return null;
  return new Intl.DateTimeFormat('pt-BR', {
    dateStyle: 'short',
    timeStyle: 'short',
  }).format(new Date(iso));
}

export default function ContactContextSection({ context, onSave, saving = false }) {
  const [editing, setEditing] = useState(false);
  const [draft, setDraft] = useState('');

  const summary = context?.progressive_summary || '';
  const hasSummary = Boolean(summary.trim());

  useEffect(() => {
    if (!editing) {
      setDraft(summary);
    }
  }, [summary, editing]);

  const handleStartEdit = () => {
    setDraft(summary);
    setEditing(true);
  };

  const handleCancel = () => {
    setDraft(summary);
    setEditing(false);
  };

  const handleSave = async () => {
    if (!onSave || saving) return;
    const ok = await onSave(draft);
    if (ok !== false) {
      setEditing(false);
    }
  };

  return (
    <section className="space-y-3">
      <div className="flex flex-wrap items-end justify-between gap-3">
        <div>
          <h2 className="text-lg font-semibold text-content-primary">Contexto</h2>
          <p className="text-xs text-content-muted mt-1">
            Resumo progressivo acumulado entre sessões
          </p>
        </div>

        {!editing && (
          <button
            type="button"
            onClick={handleStartEdit}
            className="text-sm text-forge-600 hover:text-forge-800 shrink-0"
          >
            {hasSummary ? 'Editar' : 'Adicionar contexto'}
          </button>
        )}
      </div>

      <div className="surface-card px-4 py-4">
        {editing ? (
          <div className="space-y-3">
            <textarea
              value={draft}
              onChange={(event) => setDraft(event.target.value)}
              rows={8}
              disabled={saving}
              className="w-full rounded-lg border border-slate-200 bg-white px-3 py-2 text-sm text-content-primary focus:outline-none focus:ring-2 focus:ring-forge-500/30 focus:border-forge-500 disabled:opacity-50"
              placeholder="Descreva o contexto acumulado deste contato..."
            />
            <div className="flex flex-wrap items-center gap-2">
              <button
                type="button"
                onClick={handleSave}
                disabled={saving}
                className="btn-primary text-sm px-4 py-2 disabled:opacity-40"
              >
                {saving ? 'Salvando...' : 'Salvar'}
              </button>
              <button
                type="button"
                onClick={handleCancel}
                disabled={saving}
                className="text-sm text-content-muted hover:text-content-primary disabled:opacity-40"
              >
                Cancelar
              </button>
            </div>
          </div>
        ) : hasSummary ? (
          <>
            {context?.updated_at && (
              <p className="text-xs text-content-muted mb-3">
                Atualizado em {formatDateTime(context.updated_at)}
              </p>
            )}
            <p className="text-sm text-content-primary whitespace-pre-wrap">{summary}</p>
          </>
        ) : (
          <p className="text-sm text-content-subtle italic">
            Nenhum contexto acumulado ainda.
          </p>
        )}
      </div>
    </section>
  );
}
